export enum AbTestExperiments {
  HideBiometricsSetupLater = 'hide_biometrics_setup_later',
}

export type AbTestExperiment = AbTestExperiments;

export type AbTestExperimentEvaluatorFunction = (group: string) => boolean;

export type AbTestExperimentEvaluatorMap = Record<
  AbTestExperiment,
  AbTestExperimentEvaluatorFunction
>;

export type HideBiometricsSetupLaterExperimentEvaluator = AbTestExperimentEvaluatorFunction;
